import { render, staticRenderFns } from "./IconClose.vue?vue&type=template&id=3cae850b&"
import script from "./IconClose.vue?vue&type=script&lang=ts&"
export * from "./IconClose.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports